import { Checkbox, FormControlLabel, FormGroup, FormLabel, Grid } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { DynamicFormControl, SelectOption } from "../../../";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { LocalizedStringsMethods } from "react-localization";

function CheckboxControl(props: DynamicFormControl) {

    const [formValues, setFormValues] = useState<boolean[]>([]);
    const valueRef = useRef<string | string[] | null>(null);

    const { currentLanguage } = useTranslateDetection();

    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);

    const handleChange = useCallback((event: any, item: string, index: number) => {
        const checked: boolean = event.target.checked;
        let valueArray = valueRef.current as string[] ?? [];

        if (checked) {
            valueArray.push(item);
        } else {
            valueArray = valueArray.filter(x => x !== item);
        }

        if (props.setState) {
            props.setState(valueArray);
        }
        valueRef.current = valueArray;
    }, []);

    if (props.updater != null) {
        props.updater.setValue = value => {
            if (value === '') {
                const updatedCheckedState = formValues.map(x => false);

                setFormValues(updatedCheckedState);
            }
        };
    }

    return (

        <FormGroup id={props.id}>
            <FormLabel>{props.label}</FormLabel>
            <Grid container spacing={2} direction="row" alignItems="center">

                {props.selectOptions?.map((x, i) => {
                    const option = x as SelectOption;
                    let optionLabel = option?.label ?? x;
                    const optionValue = option?.value ?? x;

                    let hasLocalization = false;
                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <Grid key={optionValue} item
                            xs={props.subGridSize?.xs}
                            sm={props.subGridSize?.sm}
                            md={props.subGridSize?.md}
                            lg={props.subGridSize?.lg}
                            xl={props.subGridSize?.xl}>
                            <FormControlLabel control={<Checkbox disabled={props.disabled} onChange={(e) => handleChange(e, optionValue, i)} />} label={optionLabel}
                                className={props.skipTranslation || hasLocalization ? "notranslate" : undefined} />
                        </Grid>
                    )
                })}


                {props.selectPropertyOptions?.map((x, i) => {
                    const option = x.label as SelectOption;
                    let optionLabel = option?.label ?? option;
                    const optionValue = option?.value ?? option;

                    let hasLocalization = false;
                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <Grid key={optionValue} item
                            xs={props.subGridSize?.xs}
                            sm={props.subGridSize?.sm}
                            md={props.subGridSize?.md}
                            lg={props.subGridSize?.lg}
                            xl={props.subGridSize?.xl}>
                            <FormControlLabel control={<Checkbox disabled={props.disabled} onChange={(e) => handleChange(e, optionValue, i)} />}
                                label={optionLabel} className={props.skipTranslation || hasLocalization ? "notranslate" : undefined} />
                        </Grid>
                    )
                })}
            </Grid>
        </FormGroup>
    );
}

export default CheckboxControl;